import serializeFormValues from '@newswebsiteapp/shared/lib/serializeFormValues'
import getCsrfToken from '@newswebsiteapp/shared/lib/getCsrfToken'

export default function showAndSetupModal({ bank_account, customer_id }) {
  $('.modal#verify_bank_account').modal()

  const form = $('form#verify-bank-account-form')

  /// ////////////////

  const submitButtonHtmlOld = form.find('[type="submit"]').html()

  const submitButtonReset = () => {
    form.find('[type=submit]').prop('disabled', false).html(submitButtonHtmlOld)
  }

  const submitButtonShowProcessing = () => {
    form
      .find('[type="submit"]')
      .prop('disabled', true)
      .html("<i class='fa fa-spinner fa-spin'></i> Processing...")
  }

  /// ////////////////

  const errorsReset = () => {
    form.find('.submit-errors-block').removeClass('alert alert-danger').text('')
  }

  const errorsShow = (text) => {
    form.find('.submit-errors-block').addClass('alert alert-danger').text(text)
  }

  form
    .find('[type="submit"]')
    .off()
    .click((event) => {
      // event.preventDefault()

      ; (async () => {
        errorsReset()

        form.validate()

        if (!form.valid()) {
          return
        }

        const formValues = serializeFormValues(form)
        submitButtonShowProcessing()

        const validateBankAccount = await $.ajax({
          type: 'post',
          url: '/profile/payment-methods/verify-bank-account',
          headers: { 'X-CSRF-Token': getCsrfToken() },
          data: {
            bank_account,
            customer_id,
            microcharges: [formValues.amount1, formValues.amount2],
          },
        })

        if (validateBankAccount.error) {
          errorsShow(validateBankAccount.error.message)
          submitButtonReset()
        }
      })()

      return false
    })
}
